import React from 'react';
import { Check, X } from 'lucide-react';

const FormulaStatusPanel = ({ allSatisfied }) => {
  return (
    <div className={`rounded-lg shadow-md p-4 ${allSatisfied ? 'bg-green-100 border-2 border-green-500' : 'bg-red-100 border-2 border-red-500'}`}>
      <h3 className="font-bold text-lg mb-2">Formula Status</h3>
      <div className="flex items-center gap-2">
        {allSatisfied ? (
          <><Check className="text-green-600" size={24} /><span className="text-green-800 font-semibold">SATISFIABLE</span></>
        ) : (
          <><X className="text-red-600" size={24} /><span className="text-red-800 font-semibold">NOT SATISFIED</span></>
        )}
      </div>
    </div>
  );
};

export default FormulaStatusPanel;